import * as React from 'react';
import classnames from 'classnames';

export type ButtonGroupProps = {
    children: React.ReactNode;
    spacing?: 'compact' | 'base';
    direction?: 'horizontal' | 'vertical';
    extraClass?: string;
    align?: 'left' | 'center' | 'right';
};

const ButtonGroup: React.FC<ButtonGroupProps> = ({
    children,
    spacing = 'base',
    direction = 'horizontal',
    align = 'center',
    extraClass,
}) => {
    const className = classnames({
        'button-group': true,
        [`button-group--spacing-${spacing}`]: true,
        [`button-group--${direction}`]: true,
        [`button-group--${align}`]: align,
        [`button-group--${extraClass}`]: extraClass,
    });

    return (
        <div className={className}>
            {React.Children.toArray(children)
                .filter(Boolean)
                .map((child, index) => (
                    <div className="button-group__item" key={index}>
                        {child}
                    </div>
                ))}
        </div>
    );
};

export default ButtonGroup;
